import { MessageType } from '../../enums/message-type';
import { NimbusUserSettings } from '../nimbus-user-settings';
import { WebViewMessage } from './web-view-message';

export class UpdateSettingsMessage extends WebViewMessage {
  public constructor(public nimbusUserSettings: NimbusUserSettings) {
    super(MessageType.UpdateSettings);
  }
}
